'use client';

import { styled } from '@linaria/react';
import { NewsCategory } from '@fe-news/constants/categories';
import navigation from '@fe-news/configs/navigation';
import Link from 'next/link';
import { CustomEventName, GTMEventKey, sendGTM } from '@fe-cnyes/fe-common-gtm';

const MY_TRACK_CATEGORIES = {
  [NewsCategory.MY_TAG]: {
    title: navigation[NewsCategory.MY_TAG].name,
    link: navigation[NewsCategory.MY_TAG].link
  },
  [NewsCategory.PORTFOLIOS]: {
    title: navigation[NewsCategory.PORTFOLIOS].name,
    link: navigation[NewsCategory.PORTFOLIOS].link
  },
  [NewsCategory.MY_POP_TOPIC]: {
    title: navigation[NewsCategory.MY_POP_TOPIC].name,
    link: navigation[NewsCategory.MY_POP_TOPIC].link
  }
};

const RANKING_LIST_CATEGORIES = {
  tracking: {
    title: '熱門追蹤排行',
    link: `${navigation[NewsCategory.RANKING_LIST].link}?type=tracking`
  },
  collect: {
    title: '熱門收藏排行',
    link: `${navigation[NewsCategory.RANKING_LIST].link}?type=collect`
  }
};

const Container = styled.div`
  display: flex;
  align-items: center;
  column-gap: 16px;
`;

const Button = styled.button<{ currentCategory: boolean; isRankingList: boolean }>`
  padding: 9px 12px;
  border-radius: 6px;
  background-color: ${({ currentCategory }) => (currentCategory ? 'rgba(224, 63, 25, 0.12)' : 'transparent')};
  cursor: pointer;

  a {
    color: ${({ currentCategory }) => (currentCategory ? '#e03f19' : '#848d97')};
    line-height: 1;
    letter-spacing: 0.5px;
    font-size: ${({ isRankingList }) => (isRankingList ? '16px' : '15px')};
  }
`;

type MemberSubHeaderProps = {
  category: NewsCategory.MY_TAG | NewsCategory.PORTFOLIOS | NewsCategory.MY_POP_TOPIC | NewsCategory.RANKING_LIST;
  type?: 'tracking' | 'collect';
};

const MemberSubHeader = ({ category, type }: MemberSubHeaderProps) => {
  const isRankingList = category === NewsCategory.RANKING_LIST;
  const list = isRankingList ? RANKING_LIST_CATEGORIES : MY_TRACK_CATEGORIES;

  const currentCategory = (childCategory: string) => {
    if (isRankingList) {
      return type === childCategory;
    }
    return category === childCategory;
  };

  return (
    <Container>
      {Object.entries(list).map(([key, value]) => {
        const GTM_EVENT = {
          [GTMEventKey.EVENT_NAME]: CustomEventName.CLICK_TAB,
          [GTMEventKey.SECTION]: isRankingList ? 'News_Category_熱門排行' : 'News_Category_我的追蹤',
          [GTMEventKey.CLICK_ITEM]: isRankingList ? value.title : `追蹤的標籤＿${value.title}`
        };

        const onClick = () => {
          sendGTM(GTM_EVENT);
        };

        return (
          <Button
            key={key}
            currentCategory={currentCategory(key)}
            aria-current={currentCategory(key) ? 'page' : undefined}
            isRankingList={isRankingList}
          >
            <Link href={value.link} onClick={onClick} prefetch={false}>
              {value.title}
            </Link>
          </Button>
        );
      })}
    </Container>
  );
};

export default MemberSubHeader;
